import ArticleLayout from '@/components/feature/ArticleLayout';
import { kakobuyArticleContent } from '@/mocks/seoContent';

export default function KakobuyArticle() {
  return (
    <ArticleLayout
      article={kakobuyArticleContent}
      heroImage="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20in%20terracotta%20sand%20and%20clay%20tones%2C%20minimalist%20art%20with%20organic%20overlapping%20shapes%2C%20soft%20gradients%2C%20modern%20brand%20design%20aesthetic%2C%20clean%20editorial%20style%2C%20warm%20earthy%20palette%2C%20subtle%20texture%20and%20depth&width=1200&height=600&seq=article-kakobuy-hero-v3&orientation=landscape"
      heroImageAlt="Kakobuy Spreadsheet trend research and product discovery platform"
      heroImageTitle="Kakobuy Spreadsheet 2026 Complete Guide"
      tag="Guide"
      relatedArticles={[
        { title: "Hipobuy Spreadsheet Guide", slug: "hipobuy-spreadsheet-guide" },
        { title: "CSSBuy Spreadsheet Guide", slug: "cssbuy-spreadsheet" },
        { title: "Superbuy Spreadsheet Guide", slug: "superbuy-spreadsheet" },
        { title: "Oopbuy Spreadsheet Guide", slug: "oopbuy-spreadsheet" },
      ]}
    />
  );
}